import { ReactNode } from 'react';

import { SummaryItem } from './SummaryItem.component';

import { SummaryItemsContainer, SummaryItemsStyled, SummaryTitle } from './SummaryItems.styles';

export interface SummaryItemsProps {
  children?: ReactNode;
}

export function SummaryItems({ children, ...props }: SummaryItemsProps) {
  return <SummaryItemsStyled {...props}>{children}</SummaryItemsStyled>;
}

SummaryItems.Title = SummaryTitle;
SummaryItems.ItemsContainer = SummaryItemsContainer;
SummaryItems.Item = SummaryItem;
